import React from 'react';
import { Link } from 'react-router-dom';

/**
 * NotFound Component (404 Page)
 * 
 * Displayed when user navigates to a route that doesn't exist
 */
function NotFound() {
  return (
    <div className="container text-center" style={{ minHeight: '70vh', paddingTop: '100px' }}>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h1 className="display-1 fw-bold text-light" style={{ fontSize: '8rem' }}>
            404
          </h1>
          <h2 className="mb-4 text-light">
            Page Not Found
          </h2>
          <p className="lead text-secondary mb-5">
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <Link 
              to="/" 
              className="btn btn-primary btn-lg px-4"
              style={{
                backgroundColor: 'var(--color-primary)',
                borderColor: 'var(--color-primary)',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Go Home
            </Link>
            <Link 
              to="/portfolio" 
              className="btn btn-outline-light btn-lg px-4"
              style={{
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              View Portfolio
            </Link>
            <Link 
              to="/contact" 
              className="btn btn-outline-light btn-lg px-4"
              style={{
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              Contact Me
            </Link>
          </div>

          <div className="mt-5">
            <svg 
              width="200" 
              height="200" 
              viewBox="0 0 200 200" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              style={{ opacity: 0.2 }}
            >
              <circle cx="100" cy="100" r="80" stroke="#6c757d" strokeWidth="2" strokeDasharray="5,5"/>
              <path 
                d="M70 80 Q100 110 130 80" 
                stroke="#6c757d" 
                strokeWidth="3" 
                fill="none"
                strokeLinecap="round"
              />
              <circle cx="75" cy="70" r="5" fill="#6c757d"/>
              <circle cx="125" cy="70" r="5" fill="#6c757d"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
